import React, { useState, useRef, useEffect, Fragment } from "react";
import { Link } from "react-router-dom";
import PageTitle from "../../../layouts/PageTitle";
import { post } from "../../../Helper/api_helper";
import swal from "sweetalert";
import { t } from "i18next";
import { Spin } from "antd";
import PaginationButtons from "../../../Custom/Pagination";
import {
  POST_GetClientsList,
  POST_ClientSetActiveInActive,
  POST_ClientDelete,
} from "../../../Helper/url_helper";
const ClientList = () => {
  const [recordCount, setRecordCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentSizePerPage, setCurrentSizePerPage] = useState(10);
  const [clientList, setClientList] = useState([]);
  const [search, setSearch] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  var objLogin = JSON.parse(localStorage.getItem("userDetails"));

  const handleOnChangeSearch = (e) => {
    setSearch(e.target.value);
  };

  useEffect(() => {
    getData();
  }, [search]);

  const getData = async (page = 1, sizePerPage = 10) => {
    setIsLoading(true);
    let response = await post(POST_GetClientsList, {
      CurrentPage: page,
      PageSize: sizePerPage,
      Search: search,
      Sorting: "",
      LoginID: objLogin.LoginIDEncrypt,
    });
    setIsLoading(false);
    setRecordCount(response.TotalRecordCount);
    setClientList(response.ClientList);
    //setCurrentPage(page);
    setCurrentSizePerPage(sizePerPage);
    if (page > 1 && response?.ClientList?.length === 0) {
      setCurrentPage(page - 1);
      getData(page - 1);
    } else {
      setCurrentPage(page);
    }
  };

  const delete_Client = (cID) => {
    swal({
      title: "Are you sure you want to delete the client?",
      text: "You won't be able to revert this!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((confirmDelete) => {
      if (confirmDelete) {
        delete_ClientConfirm(cID);
      }
    });
  };

  const delete_ClientConfirm = async (cID) => {
    setIsLoading(true);
    let response = await post(POST_ClientDelete, {
      EncryptedClientID: cID,
      EncryptedModifiedBy: objLogin.LoginIDEncrypt,
    });
    if (response.IsSuccess) {
      swal({
        title: "Deleted",
        text: "Record has been deleted.",
        icon: "success",
        button: "OK",
      });
      getData(currentPage, currentSizePerPage);
    } else {
      swal("Error!", t(response.MessageCode), "error");
    }
    setIsLoading(false);
  };

  const ActiveInactive_Client = async (cID, cStatus) => {
    swal({
      title: `Are you sure you want to ${
        cStatus ? "inactive" : "active"
      } the client?`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((confirmStatus) => {
      if (confirmStatus) {
        ActiveInactive_ClientConfirm(cID, cStatus);
      }
    });
  };

  const ActiveInactive_ClientConfirm = async (cID, cStatus) => {
    setIsLoading(true);
    let response = await post(POST_ClientSetActiveInActive, {
      EncryptedClientID: cID,
      IsActive: !cStatus,
      EncryptedModifiedBy: objLogin.LoginIDEncrypt,
    });
    if (response.IsSuccess) {
      swal({
        title: cStatus ? "Inactivated" : "Activated",
        text: cStatus
          ? "Record has been Inactivated."
          : "Record has been Activated.",
        icon: "success",
        button: "OK",
      });
      getData(currentPage, currentSizePerPage);
    } else {
      swal("Error!", t(response.MessageCode), "error");
    }
    setIsLoading(false);
  };

  return (
    <>
      <Fragment>
        <Spin size="large" spinning={isLoading} tip={"Loading..."}>
          <PageTitle motherMenu="Master" activeMenu="Clients" />

          <div className="form-head d-flex mb-3 mb-md-4 align-items-start">
            <div className="mr-auto d-lg-block">
              {/* <Link
              to="/add-clients"
              className="btn btn-primary btn-xs btn-rounded"
            >
              + Add Client
            </Link> */}
            </div>
            <div className="input-group search-area ml-auto d-inline-flex mr-3">
              <input
                type="text"
                style={{ height: "36px" }}
                className="form-control"
                placeholder="Search here"
                value={search}
                onChange={handleOnChangeSearch}
              />
              <div className="input-group-append">
                <button type="button" className="input-group-text">
                  <i className="flaticon-381-search-2" />
                </button>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-12">
              <div className="table-responsive">
                <div id="client_list" className="dataTables_wrapper no-footer">
                  <table
                    id="example5"
                    className="table table-striped patient-list mb-4 dataTablesCard fs-14 dataTable no-footer"
                    role="grid"
                    aria-describedby="example5_info"
                  >
                    <thead>
                      <tr role="row">
                        <th
                          className="sorting"
                          tabIndex={0}
                          aria-controls="example5"
                          rowSpan={1}
                          colSpan={1}
                          aria-label="Client Name: activate to sort column ascending"
                          style={{ width: "25%" }}
                        >
                          Client Name
                        </th>
                        <th
                          className="sorting"
                          tabIndex={0}
                          aria-controls="example5"
                          rowSpan={1}
                          colSpan={1}
                          aria-label="Mobile Number: activate to sort column ascending"
                          style={{ width: "20%" }}
                        >
                          Mobile Number
                        </th>
                        <th
                          className="sorting"
                          tabIndex={0}
                          aria-controls="example5"
                          rowSpan={1}
                          colSpan={1}
                          aria-label="Email ID: activate to sort column ascending"
                          style={{ width: "30%" }}
                        >
                          Email ID
                        </th>
                        <th
                          className="sorting"
                          tabIndex={0}
                          aria-controls="example5"
                          rowSpan={1}
                          colSpan={1}
                          aria-label="Gender: activate to sort column ascending"
                          style={{ width: "15%" }}
                        >
                          Gender
                        </th>

                        <th
                          className="sorting"
                          tabIndex={0}
                          aria-controls="example5"
                          rowSpan={1}
                          colSpan={1}
                          aria-label="Actions: activate to sort column ascending"
                          style={{ width: "10%" }}
                        >
                          Actions
                        </th>
                      </tr>
                    </thead>
                    {recordCount > 0 ? (
                      <tbody>
                        {clientList?.map((element, i) => (
                          <tr role="row" className="odd">
                            <td>{element.ClientName}</td>
                            <td>{element.MobileNo}</td>
                            <td>{element.EmailID}</td>
                            <td>{element.Gender}</td>
                            <td>
                              <div className="d-flex">
                                <Link
                                  to={`/edit-clients/${window.btoa(
                                    element.ClientIDEncrypt
                                  )}`}
                                  className="btn btn-light shadow btn-xs sharp mr-1"
                                  title="Edit"
                                >
                                  <i className="fa fa-pencil"></i>
                                </Link>
                                <Link
                                  to="#"
                                  className="btn btn-light shadow btn-xs sharp mr-1 rounded-circle"
                                  title={
                                    element.IsActive ? "Active" : "Inactive"
                                  }
                                  onClick={() => {
                                    ActiveInactive_Client(
                                      element.ClientIDEncrypt,
                                      element.IsActive
                                    );
                                  }}
                                >
                                  <i
                                    className="fa fa-circle mt-1"
                                    style={{
                                      color: element.IsActive ? "green" : "red",
                                    }}
                                  ></i>
                                </Link>
                                <Link
                                  to="#"
                                  className="btn btn-light shadow btn-xs sharp"
                                  title="Delete"
                                  onClick={() => {
                                    delete_Client(element.ClientIDEncrypt);
                                  }}
                                >
                                  <i
                                    className="fa fa-trash"
                                    style={{ color: "red" }}
                                  ></i>
                                </Link>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    ) : (
                      <div className="mt-3 ml-3">{"No Record Found"}</div>
                    )}
                  </table>
                  <div className="d-sm-flex text-center justify-content-between align-items-center">
                    <div
                      className="dataTables_info"
                      id="example5_info"
                      role="status"
                      aria-live="polite"
                    >
                      Showing{" "}
                      {recordCount > 0
                        ? (currentPage - 1) * currentSizePerPage + 1
                        : 0}{" "}
                      to{" "}
                      {recordCount > currentPage * currentSizePerPage
                        ? currentPage * currentSizePerPage
                        : recordCount}{" "}
                      of {recordCount} entries
                    </div>
                    <div className="paging_simple_numbers d-flex  justify-content-center align-items-center">
                      <PaginationButtons
                        totalPages={recordCount / currentSizePerPage}
                        currentPage={currentPage}
                        getData={getData}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Spin>
      </Fragment>
    </>
  );
};

export default ClientList;
